import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

export interface FooterButton {
  label: string;
  callback: any;
  loadingCompleteLabel?: string;
  loadingLabel?: string;
  loadingComplete?: boolean;
  loading?: boolean;
}

@Component({
  selector: 'app-desktop-footer',
  templateUrl: './desktop-footer.component.html',
  styleUrls: ['./desktop-footer.component.scss']
})
export class DesktopFooterComponent implements OnInit, OnChanges {
  @Input() buttons: FooterButton[];
  @Input() loading: boolean;
  public footerButtons: FooterButton[];
  public loadingComplete = false;
  private iconVisibilityDuration = 2000;
  private delayTimer: any;

  constructor() {}

  ngOnInit(): void {
    this.footerButtons = Array.from(this.buttons);
    this.footerButtons.reverse();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.loading && changes.loading.previousValue !== undefined) {
      if (changes.loading.currentValue === false) {
        this.handleLoadingComplete();
      } else {
        this.loadingComplete = false;
      }
    } else if ( changes.buttons ) {
      this.footerButtons = Array.from(this.buttons);
      this.footerButtons.reverse();
    }
  }
  async handleLoadingComplete(): Promise<void> {
    clearTimeout(this.delayTimer);
    this.loadingComplete = true;
    await new Promise(resolve => this.delayTimer = setTimeout(resolve, this.iconVisibilityDuration));
    this.loadingComplete = false;
  }
}
